import { render, staticRenderFns } from "./component-title.vue?vue&type=template&id=e867dac6&scoped=true&"
import script from "./component-title.vue?vue&type=script&lang=js&"
export * from "./component-title.vue?vue&type=script&lang=js&"
import style0 from "./component-title.vue?vue&type=style&index=0&id=e867dac6&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e867dac6",
  null
  
)

export default component.exports